"use strict";
/**
 * web接口配置
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var url_1 = __importDefault(require("../modules/url"));
var rnd = Math.floor(Math.random() * 99 + 1);
var rnd2 = Math.floor(Math.random() * 99 + 1);
var config = {
    test: {
        quote_api: "//push2test.eastmoney.com/",
        quote_push_api: "//push2test.eastmoney.com/",
        quote_history_api: "//push2test.eastmoney.com/",
        quote_history_push_api: "//push2test.eastmoney.com/",
        qihuo_api: "//futssetest.eastmoney.com/",
        qihuo_sse_api: "http://futssetest.eastmoney.com/",
        qihuo_static: "//static.futssetest.eastmoney.com/",
        news_api: '//cmsdataapi.emapd.com/'
    },
    prod: {
        quote_api: "//push2.eastmoney.com/",
        quote_push_api: "//" + rnd + ".push2.eastmoney.com/",
        quote_history_api: "//push2his.eastmoney.com/",
        quote_history_push_api: "//" + rnd2 + ".push2his.eastmoney.com/",
        qihuo_api: "//futsseapi.eastmoney.com/",
        qihuo_sse_api: "//" + rnd2 + ".futsseapi.eastmoney.com/",
        qihuo_static: "//futsse-static.eastmoney.com/",
        news_api: '//cmsdataapi.eastmoney.com/'
    },
    getUrl: function (name) {
        var env = url_1.default.getQuery('env');
        if (env == "test") {
            return this.test[name];
        }
        return this.prod[name];
    }
};
exports.default = config;
